import appApi from '../../../../../../../../api/app-api';
import externalExamGroupsStore from '../../../../../../../../stores/external-exam-groups-store';
import { toast } from 'react-toastify';
import { displayErrorText } from '../../../../../../../../api/errors/api-error-codes';

export const deleteExamFromGroupOperation = async (
  groupId: number,
  examId: number,
  setExamId: (examId: number | null) => any,
  onSuccess: () => void,
) => {
  try {
    setExamId(examId);

    const res = await appApi.deleteExamFromGroup(groupId, examId);

    if (res.data.ok) {
      await externalExamGroupsStore.fetchGroups();
      toast.success('מבחן נמחק מהמקבץ בהצלחה');
      onSuccess();
    } else if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
    }

    setExamId(null);
  } catch (e) {
    setExamId(null);
    console.error(`deleteExamFromGroupOperation failed: ${e}`);
  }
};
